export const LogoDropdown = {
  Logo: {
    pointerEvents: 'none',
    position: 'relative',
    top: 'auto',
    left: 'auto',
    style: { color: 'currentColor' },
    Dropdown: null,
  },
  Dropdown: null,
  DropdownArrow: {
    margin: '- W2 - -',
  },
  Dropdown_2: {
    left: '-Z',
    'Dropdown.Logo': {},
  },
  extends: [
    'CanvasButton',
    'DropdownParentFocus',
  ],
  flow: 'x',
  round: 'C1',
  align: 'center',
  padding: 'W',
};